import React from 'react';
import Members from '../../../../Components/Icons/Member';
import UseGetDashBoardData from '../../../../Components/Hooks/useDashboardData';

function Contracts() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/active-contracts`);

  return (
    <div className="col-span-2 bg-gradient-to-br from-white to-gray-50 h-[22vh]  w-full p-4 rounded-2xl shadow-lg flex flex-col justify-between">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h3 className="text-gray-700 text-sm font-semibold">Active Contracts</h3>
        <div className="bg-green-100 text-green-500 p-2 rounded-full shadow-sm">
        <svg
            width="20"
            height="20"
            fill="#048178"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
          >
            <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
          </svg>  </div>
      </div>

          <div>
        <p className="text-xl font-bold text-gray-800">{data?.total}</p>
        {/* <p className="text-xs text-gray-500">Total Active Contracts</p> */}
      </div>

      {/* Status */}
      <div className="text-xs mt-2">
        <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-lg font-medium">
          {data?.pending_renewals} Pending Renewals
        </span>
      </div>
    </div>
  );
}

export default Contracts;
